import React from "react";

const COLS = 18;
const bits = (n, seed) => Array.from({ length: n }, (_, i) => ((i * 7 + seed * 13) % 5 > 1 ? "1" : "0")).join("\n");

export function StageBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_50%_at_50%_0%,rgba(56,189,248,0.18),transparent_70%)]" />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-[radial-gradient(ellipse_80%_60%_at_50%_100%,rgba(91,61,224,0.35),transparent_70%)]" />
      {Array.from({ length: COLS }, (_, i) => {
        const edge = i < COLS / 2 ? i : COLS - 1 - i;
        if (edge > 3) return null;
        const left = i < COLS / 2 ? `${2 + i * 4}%` : `${96 - (COLS - 1 - i) * 4}%`;
        return (
          <pre key={i} className="winners-rain absolute top-0 font-mono text-[11px] leading-[13px] text-sky-500"
            style={{ left, opacity: 0.08 + (3 - edge) * 0.06, animationDuration: `${9 + ((i * 5) % 7)}s`, animationDelay: `-${(i * 3) % 9}s` }}>
            {bits(80, i)}
          </pre>
        );
      })}
    </div>
  );
}
